import type { Yacht } from "./yachts";

const SCI = "https://www.smartcharteribiza.com/wp-content/uploads";

// Additional fleet from partner charter collection
export const charterFleet: Yacht[] = [
  {
    slug: "brig-650",
    name: "Brig 650",
    boatName: "Speedy",
    image: `${SCI}/2019/04/Brig-_Speedy_-Ibiza.jpeg`,
    images: [
      `${SCI}/2019/04/Brig-_Speedy_-Ibiza.jpeg`,
      `${SCI}/2019/04/BRIG_HIGH_RES-19-e1676628669611.jpg`,
      `${SCI}/2019/04/BRIG_HIGH_RES-25.jpg`,
      `${SCI}/2019/04/BRIG_HIGH_RES-22.jpg`,
      `${SCI}/2019/04/BRIG_HIGH_RES-11.jpg`,
    ],
    length: "21 ft / 6.5 m",
    guests: "Up to 8 guests",
    cabins: "—",
    cruisingSpeed: "30 knots",
    crew: "Captain",
    features: "Open deck layout, swim ladder, compact cockpit",
    marina: "Marina Ibiza",
    pricing: { low: "€500", mid: "€599", high: "€700" },
    priceNote: "Price does not include skipper (+€200), VAT or fuel.",
    includes: ["Mooring", "Snorkels", "Towels"],
    description:
      "The Brig 650 is a nimble and versatile speedboat perfect for intimate coastal explorations. Its compact design allows easy access to hidden coves and shallow bays that larger vessels cannot reach. Ideal for small groups seeking a fun and affordable day on the water around Ibiza.",
  },
  {
    slug: "chris-craft-28",
    name: "Chris Craft 28",
    boatName: "Yootopia",
    image: `${SCI}/2019/04/Rent-Chris-Craft-Ibiza.jpg`,
    images: [
      `${SCI}/2019/04/Rent-Chris-Craft-Ibiza.jpg`,
      `${SCI}/2019/04/CHRIS_CRAFT28_HIGH_RES.jpg`,
    ],
    length: "28 ft / 7.65 m",
    guests: "Up to 9 guests",
    cabins: "—",
    cruisingSpeed: "28 knots",
    crew: "Captain",
    features: "Classic styling, teak accents, bow seating",
    marina: "Marina Ibiza",
    pricing: { low: "€999", mid: "€1,199", high: "€1,299" },
    priceNote: "Price does not include skipper (+€200), VAT or fuel.",
    includes: ["Mooring", "Beverages", "Snorkels", "Towels"],
    description:
      "The Chris Craft 28 is a beautifully styled American classic, known for its timeless teak detailing and refined lines. The open bow offers generous seating for sunbathing, while the cockpit provides a comfortable area for socializing. A boat that combines heritage craftsmanship with modern performance.",
  },
  {
    slug: "sunseeker-tomahawk-37",
    name: "Sunseeker Tomahawk 37",
    boatName: "My Way",
    image: `${SCI}/2016/03/Sunseeker-37-8.jpg`,
    images: [
      `${SCI}/2016/03/Sunseeker-37-8.jpg`,
    ],
    length: "37 ft / 11.3 m",
    guests: "Up to 9 guests",
    cabins: "1",
    cruisingSpeed: "32 knots",
    crew: "Captain",
    features: "Sport cockpit, bow sunbed, cabin lounge",
    marina: "Marina Ibiza",
    pricing: { low: "€1,299", mid: "€1,499", high: "€1,699" },
    priceNote: "Price does not include skipper (+€200), VAT or fuel.",
    includes: ["Mooring", "Beverages", "Snorkels", "Towels"],
    description:
      "The Sunseeker Tomahawk 37 delivers thrilling performance wrapped in British luxury design. Its aggressive lines and powerful engines make it a head-turner on the water, while the comfortable cockpit and cabin below provide all the amenities needed for a refined day at sea.",
  },
  {
    slug: "sunseeker-40",
    name: "Sunseeker Superhawk 40",
    boatName: "Great News",
    image: `${SCI}/2017/04/Rent-boat-Ibiza-_Great-News_.jpeg`,
    images: [
      `${SCI}/2017/04/Rent-boat-Ibiza-_Great-News_.jpeg`,
      `${SCI}/2017/04/DH2A1179-1.jpeg`,
      `${SCI}/2017/04/DH2A1177.jpeg`,
    ],
    length: "40 ft / 12.2 m",
    guests: "Up to 8 guests",
    cabins: "1",
    cruisingSpeed: "34 knots",
    crew: "Captain",
    features: "Sporty profile, aft sunbed, cockpit lounge",
    marina: "Marina Ibiza",
    pricing: { low: "€1,499", mid: "€1,699", high: "€1,899" },
    priceNote: "Price does not include skipper (+€200), VAT or fuel.",
    includes: ["Mooring", "Beverages", "Paddle Surf", "Snorkels", "Towels"],
    description:
      "The Sunseeker Superhawk 40 combines raw speed with refined British craftsmanship. Its sporty silhouette cuts through the waves with confidence, while the spacious cockpit and aft sunbed offer relaxation between high-speed runs along the Ibiza coastline.",
  },
  {
    slug: "sacs-44",
    name: "SACS 44",
    boatName: "Bolero III",
    image: `${SCI}/2025/06/44_Sacs_Bolero_III.png`,
    images: [
      `${SCI}/2025/06/44_Sacs_Bolero_III.png`,
      `${SCI}/2025/06/44_Sacs_Bolero_III_1.png`,
    ],
    length: "44 ft / 13.4 m",
    guests: "Up to 12 guests",
    cabins: "1",
    cruisingSpeed: "30 knots",
    crew: "Captain",
    features: "RIB design, large deck, stability in open seas",
    marina: "Marina Ibiza",
    pricing: { low: "€1,499", mid: "€1,699", high: "€1,899" },
    priceNote: "Price does not include skipper (+€200), VAT or fuel.",
    includes: ["Mooring", "Beverages", "Paddle Surf", "Snorkels", "Towels"],
    description:
      "The SACS 44 is a premium Italian RIB that blends robust performance with luxury comfort. Its rigid inflatable design provides exceptional stability and safety, even in choppy conditions. The generous deck space accommodates larger groups, making it perfect for social day charters.",
  },
  {
    slug: "sunseeker-superhawk-48",
    name: "Sunseeker Superhawk 48",
    boatName: "Watch Me",
    image: `${SCI}/2016/03/Rent-boat-Ibiza-_Watch-Me_.jpeg`,
    images: [
      `${SCI}/2016/03/Rent-boat-Ibiza-_Watch-Me_.jpeg`,
    ],
    length: "48 ft / 14.6 m",
    guests: "Up to 11 guests",
    cabins: "2",
    cruisingSpeed: "35 knots",
    crew: "Captain",
    features: "Sport yacht profile, saloon, bow sunbed, swim platform",
    marina: "Marina Ibiza",
    pricing: { low: "€1,499", mid: "€1,699", high: "€1,899" },
    priceNote: "Price does not include VAT or fuel.",
    includes: ["Skipper", "Mooring", "Beverages", "Paddle Surf", "Snorkels", "Towels"],
    description:
      "The Sunseeker Superhawk 48 is a performance-oriented yacht that delivers exhilarating speed without compromising on luxury. Its sleek British design features a well-appointed saloon, spacious bow sunbed, and generous swim platform for effortless water access.",
  },
  {
    slug: "saxdor-320",
    name: "Saxdor 320 GTO",
    boatName: "GTO",
    image: `${SCI}/2023/02/Rent-Saxdor-Ibiza.jpg`,
    images: [
      `${SCI}/2023/02/Rent-Saxdor-Ibiza.jpg`,
    ],
    length: "32 ft / 10.9 m",
    guests: "Up to 8 guests",
    cabins: "1",
    cruisingSpeed: "24 knots",
    crew: "Captain",
    features: "Sport hull design, T-top, social cockpit",
    marina: "Marina Ibiza",
    pricing: { low: "€1,699", mid: "€1,799", high: "€2,099" },
    priceNote: "Price does not include skipper (+€200), VAT or fuel.",
    includes: ["Mooring", "Beverages", "Snorkels", "Towels"],
    description:
      "The Saxdor 320 GTO pushes the boundaries of modern boat design with its innovative hull and bold styling. Equipped with a T-top for shade and a sporty cockpit layout, it offers the perfect balance between thrilling performance and relaxed comfort for day cruises.",
  },
  {
    slug: "van-dutch-40",
    name: "Van Dutch 40",
    boatName: "Smart Ass",
    image: `${SCI}/2019/04/Van-Dutch-40-_Smart-Ass_-Ibiza.jpeg`,
    images: [
      `${SCI}/2019/04/Van-Dutch-40-_Smart-Ass_-Ibiza.jpeg`,
      `${SCI}/2019/04/40_VAN_DUTCH_HIGH_RES-12.jpg`,
      `${SCI}/2019/04/40_VAN_DUTCH_HIGH_RES-13-1.jpg`,
      `${SCI}/2019/04/40_VAN_DUTCH_HIGH_RES.jpg`,
      `${SCI}/2019/04/40_VAN_DUTCH_HIGH_RES-21-1.jpg`,
    ],
    length: "40 ft / 12.2 m",
    guests: "Up to 9 guests",
    cabins: "1",
    cruisingSpeed: "30 knots",
    crew: "Captain",
    features: "Iconic Dutch design, open deck, luxury finishes",
    marina: "Marina Ibiza",
    pricing: { low: "€1,699", mid: "€1,899", high: "€2,099" },
    priceNote: "Price does not include skipper (+€200), VAT or fuel.",
    includes: ["Mooring", "Beverages", "Paddle Surf", "Snorkels", "Towels"],
    description:
      "The Van Dutch 40 is an icon of contemporary Dutch design, celebrated for its minimalist luxury and distinctive silhouette. The open deck layout creates a sophisticated social atmosphere, while premium materials and refined craftsmanship define every surface on board.",
  },
  {
    slug: "d34-de-antonio",
    name: "De Antonio D34",
    boatName: "Why Not",
    image: `${SCI}/2022/05/De-Antonio-34-Ibiza.jpeg`,
    images: [
      `${SCI}/2022/05/De-Antonio-34-Ibiza.jpeg`,
      `${SCI}/2022/05/DeAntonio34_Ibiza1.jpeg`,
      `${SCI}/2022/05/DeAntonio34_Ibiza.jpeg`,
    ],
    length: "34 ft / 11 m",
    guests: "Up to 9 guests",
    cabins: "1",
    cruisingSpeed: "26 knots",
    crew: "Captain",
    features: "Hidden outboard design, sunbeds, spacious deck",
    marina: "Marina Ibiza",
    pricing: { low: "€1,799", mid: "€1,999", high: "€2,299" },
    priceNote: "Price does not include skipper (+€200), VAT or fuel.",
    includes: ["Mooring", "Beverages", "Paddle Surf", "Snorkels", "Towels"],
    description:
      "The De Antonio D34 features the brand's signature hidden outboard engine design, creating a clean and spacious stern area. With generous sunbeds and a comfortable cockpit, it offers a refined cruising experience with modern styling and effortless performance.",
  },
  {
    slug: "oryx-38",
    name: "Oryx 38",
    boatName: "Orix",
    image: `${SCI}/2021/05/Rent-Oryx-Ibiza.jpeg`,
    images: [
      `${SCI}/2021/05/Rent-Oryx-Ibiza.jpeg`,
    ],
    length: "38 ft / 11.5 m",
    guests: "Up to 11 guests",
    cabins: "1",
    cruisingSpeed: "25 knots",
    crew: "Captain",
    features: "Sport cruiser profile, bow sunbed, cockpit seating, A/C, Void sound system",
    marina: "Marina Ibiza",
    pricing: { low: "€1,799", mid: "€2,199", high: "€2,599" },
    priceNote: "Price does not include skipper (+€200), VAT or fuel.",
    includes: ["Mooring", "Beverages", "Paddle Surf", "Snorkels", "Towels"],
    description:
      "The Oryx 38 is a bold sport cruiser that combines muscular design with generous living space. Its wide beam provides excellent stability and a spacious cockpit that accommodates larger groups in comfort. A capable and stylish choice for exploring the Ibiza coastline.",
  },
  {
    slug: "kumbra-34-sc",
    name: "Kumbra 34",
    boatName: "Solana",
    image: `${SCI}/2026/02/WhatsApp-Image-2026-02-12-at-13.58.13.jpeg`,
    images: [
      `${SCI}/2026/02/WhatsApp-Image-2026-02-12-at-13.58.13.jpeg`,
    ],
    length: "34 ft / 11 m",
    guests: "Up to 12 guests",
    cabins: "1",
    cruisingSpeed: "26 knots",
    crew: "Captain",
    features: "Wide sunbeds, relaxed seating, open deck",
    marina: "Marina Ibiza",
    pricing: { low: "€1,899", mid: "€2,099", high: "€2,299" },
    priceNote: "Price does not include skipper (+€200), VAT or fuel.",
    includes: ["Mooring", "Beverages", "Paddle Surf", "Snorkels", "Towels"],
    description:
      "The Kumbra 34 delivers a spacious and comfortable charter experience with its open deck design. Wide sunbeds and relaxed seating areas provide inviting spaces to unwind while cruising along the coast. Built for larger groups who value comfort and style.",
  },
  {
    slug: "technohull-40",
    name: "Technohull 40",
    boatName: "Africa",
    image: `${SCI}/2025/07/COMFORT-1920-X-1080-0145-1.jpg`,
    images: [
      `${SCI}/2025/07/COMFORT-1920-X-1080-0145-1.jpg`,
      `${SCI}/2025/07/COMFORT-1920-X-1080-0145-1-1.jpg`,
    ],
    length: "40 ft / 12 m",
    guests: "Up to 11 guests",
    cabins: "1",
    cruisingSpeed: "45 knots",
    crew: "Captain",
    features: "High-performance hull, deep-V design, sport seating",
    marina: "Marina Ibiza",
    pricing: { low: "€1,999", mid: "€2,299", high: "€2,599" },
    priceNote: "Price does not include skipper (+€200), VAT or fuel.",
    includes: ["Mooring", "Beverages", "Paddle Surf", "Snorkels", "Towels"],
    description:
      "The Technohull 40 is an engineering masterpiece built for speed enthusiasts. Its patented deep-V hull design delivers extraordinary performance and handling, even in rough conditions. Despite its sport-focused DNA, generous deck space and comfortable seating ensure luxury is never compromised.",
  },
  {
    slug: "frauscher-40",
    name: "Frauscher 1212 Ghost",
    boatName: "Viena",
    image: `${SCI}/2025/04/Frauscher-1212-Ghost-Air-Viena.webp`,
    images: [
      `${SCI}/2025/04/Frauscher-1212-Ghost-Air-Viena.webp`,
    ],
    length: "40 ft / 12.1 m",
    guests: "Up to 11 guests",
    cabins: "1",
    cruisingSpeed: "35 knots",
    crew: "Captain",
    features: "Austrian precision design, electric options, luxury deck",
    marina: "Marina Ibiza",
    pricing: { low: "€2,199", mid: "€2,499", high: "€2,799" },
    priceNote: "Price does not include skipper (+€200), VAT or fuel.",
    includes: ["Mooring", "Beverages", "Paddle Surf", "Snorkels", "Towels"],
    description:
      "The Frauscher 1212 Ghost is an Austrian-engineered masterwork that fuses cutting-edge technology with timeless design. Its clean, aerodynamic lines and premium materials create an atmosphere of quiet sophistication. A truly unique vessel for discerning guests who appreciate precision craftsmanship.",
  },
  {
    slug: "evo-43",
    name: "EVO 43",
    boatName: "Neve",
    image: `${SCI}/2024/04/EVO_43_NEVE_010.jpeg`,
    images: [
      `${SCI}/2024/04/EVO_43_NEVE_010.jpeg`,
      `${SCI}/2024/04/EVO_43_NEVE_010.png`,
    ],
    length: "43 ft / 13.1 m",
    guests: "Up to 11 guests",
    cabins: "1",
    cruisingSpeed: "28 knots",
    crew: "Captain",
    features: "Transformable deck, XTension bulwarks, luxury sunbeds",
    marina: "Marina Ibiza",
    pricing: { low: "€2,399", mid: "€2,699", high: "€2,999" },
    priceNote: "Price does not include skipper (+€200), VAT or fuel.",
    includes: ["Mooring", "Beverages", "Paddle Surf", "Snorkels", "Towels"],
    description:
      "The EVO 43 is a revolutionary Italian yacht featuring patented XTension bulwarks that expand the deck space at the touch of a button. Its innovative transformable layout creates the largest open deck area in its class, making it the ultimate platform for entertaining and relaxing.",
  },
  {
    slug: "vanquish-43",
    name: "Vanquish 43",
    boatName: "Tequila",
    image: `${SCI}/2022/11/Vanquish-43-_Tequila_-Ibiza.jpeg`,
    images: [
      `${SCI}/2022/11/Vanquish-43-_Tequila_-Ibiza.jpeg`,
      `${SCI}/2022/11/dji_0054.jpeg`,
      `${SCI}/2022/11/dji_0051-2.jpeg`,
      `${SCI}/2022/11/dji_0052-2.jpeg`,
      `${SCI}/2022/11/high_sci_interior_photos_vanquish43_tequila_2023_001.jpeg`,
    ],
    length: "43 ft / 13 m",
    guests: "Up to 11 guests",
    cabins: "1",
    cruisingSpeed: "38 knots",
    crew: "Captain",
    features: "Aluminium hull, minimalist design, premium sound",
    marina: "Marina Ibiza",
    pricing: { low: "€2,399", mid: "€2,699", high: "€2,999" },
    priceNote: "Price does not include skipper (+€200), VAT or fuel.",
    includes: ["Mooring", "Beverages", "Paddle Surf", "Snorkels", "Towels"],
    description:
      "The Vanquish 43 is a Dutch-built masterpiece crafted from lightweight aluminium, delivering exceptional speed and agility. Its minimalist yet bold design stands out in any harbour, while the open deck layout and premium sound system create the perfect atmosphere for stylish day charters.",
  },
  {
    slug: "frauscher-1414-demon",
    name: "Frauscher 1414 Demon Air",
    boatName: "Hailey Su",
    image: `${SCI}/2025/04/45_Frauscher_HaileySu_14.png`,
    images: [
      `${SCI}/2025/04/45_Frauscher_HaileySu_14.png`,
    ],
    length: "45 ft / 13.7 m",
    guests: "Up to 11 guests",
    cabins: "1",
    cruisingSpeed: "40 knots",
    crew: "Captain",
    features: "Air-step hull, Austrian design, spacious sunbeds",
    marina: "Marina Ibiza",
    pricing: { low: "€2,499", mid: "€2,799", high: "€3,099" },
    priceNote: "Price does not include skipper (+€200), VAT or fuel.",
    includes: ["Mooring", "Beverages", "Paddle Surf", "Snorkels", "Towels"],
    description:
      "The Frauscher 1414 Demon Air is the flagship of Austrian boat builder Frauscher, combining breathtaking speed with luxurious comfort. Its innovative air-step hull reduces drag for exceptional performance, while the spacious deck layout provides generous sunbathing and lounge areas.",
  },
  {
    slug: "cayman-40",
    name: "Cayman 40",
    boatName: "Caiman",
    image: `${SCI}/2022/11/Cayman-40-Ibiza.jpg`,
    images: [
      `${SCI}/2022/11/Cayman-40-Ibiza.jpg`,
    ],
    length: "40 ft / 12.2 m",
    guests: "Up to 11 guests",
    cabins: "1",
    cruisingSpeed: "30 knots",
    crew: "Captain",
    features: "Italian sport yacht, walkaround deck, luxury cockpit",
    marina: "Marina Ibiza",
    pricing: { low: "€2,599", mid: "€2,899", high: "€3,199" },
    priceNote: "Price does not include skipper (+€200), VAT or fuel.",
    includes: ["Mooring", "Beverages", "Paddle Surf", "Snorkels", "Towels"],
    description:
      "The Cayman 40 represents Italian sport yacht design at its finest. Its walkaround deck provides easy access to every area of the boat, while the luxury cockpit and generous sunbeds create comfortable spaces for relaxation. A refined choice for discerning day charters.",
  },
  {
    slug: "canados-49",
    name: "Canados 49",
    boatName: "Grand",
    image: `${SCI}/2023/02/DJI_20250406163235_0049_D.jpeg`,
    images: [
      `${SCI}/2023/02/DJI_20250406163235_0049_D.jpeg`,
      `${SCI}/2023/02/Canados_49_2.jpg`,
    ],
    length: "49 ft / 14.9 m",
    guests: "Up to 12 guests",
    cabins: "2",
    cruisingSpeed: "30 knots",
    crew: "Captain + Crew",
    features: "Luxury salon, aft deck, bow sunbed, swim platform",
    marina: "Marina Ibiza",
    pricing: { low: "€2,999", mid: "€3,299", high: "€3,599" },
    priceNote: "Price does not include VAT or fuel.",
    includes: ["Skipper", "Mooring", "Beverages", "Paddle Surf", "Snorkels", "Towels"],
    description:
      "The Canados 49 is a distinguished Italian motor yacht that exudes classic Mediterranean luxury. Its spacious aft deck and refined interior salon provide elegant entertaining spaces, while the bow sunbed and swim platform invite guests to enjoy the sea up close.",
  },
  {
    slug: "wally-tender-48",
    name: "Wally Tender 48",
    boatName: "Jemima",
    image: `${SCI}/2023/02/Wally-48-22Jemima22-Ibiza.jpg`,
    images: [
      `${SCI}/2023/02/Wally-48-22Jemima22-Ibiza.jpg`,
      `${SCI}/2023/02/SCI_MED_Exterior_Movement_Wally48_Jemima_002.jpg`,
      `${SCI}/2023/02/LOW_SCI_Wally_48_Jemima_2023_003.jpg`,
      `${SCI}/2023/02/LOW_SCI_Wally_48_Jemima_2023_005.jpg`,
      `${SCI}/2023/02/LOW_SCI_Wally_48_Jemima_2023_012.jpg`,
    ],
    length: "48 ft / 14.6 m",
    guests: "Up to 11 guests",
    cabins: "1",
    cruisingSpeed: "32 knots",
    crew: "Captain + Crew",
    features: "Iconic Wally design, carbon fibre, hydraulic bathing platform",
    marina: "Marina Ibiza",
    pricing: { low: "€3,299", mid: "€3,599", high: "€3,999" },
    priceNote: "Price does not include VAT or fuel.",
    includes: ["Skipper", "Mooring", "Beverages", "Paddle Surf", "Snorkels", "Towels"],
    description:
      "The Wally Tender 48 is an icon of contemporary yacht design, instantly recognizable for its clean, angular lines. Built with carbon fibre and advanced composites, it delivers exceptional performance with effortless grace. The hydraulic bathing platform and spacious deck create the ultimate luxury day charter experience.",
  },
  {
    slug: "canados-gladiator-49",
    name: "Canados Gladiator 49",
    boatName: "Vibe",
    image: `${SCI}/2024/10/Canados-49-_Vibe_-Ibiza.jpeg`,
    images: [
      `${SCI}/2024/10/Canados-49-_Vibe_-Ibiza.jpeg`,
    ],
    length: "49 ft / 14.9 m",
    guests: "Up to 12 guests",
    cabins: "2",
    cruisingSpeed: "35 knots",
    crew: "Captain + Crew",
    features: "Sport yacht design, open cockpit, bow lounge",
    marina: "Marina Ibiza",
    pricing: { low: "€3,299", mid: "€3,599", high: "€3,999" },
    priceNote: "Price does not include VAT or fuel.",
    includes: ["Skipper", "Mooring", "Beverages", "Paddle Surf", "Snorkels", "Towels"],
    description:
      "The Canados Gladiator 49 combines aggressive sport yacht styling with Italian luxury craftsmanship. Its powerful engines and sleek hull deliver exhilarating performance, while the open cockpit and bow lounge areas provide comfortable spaces for sun-soaked days at sea.",
  },
  {
    slug: "princess-v58",
    name: "Princess V58",
    boatName: "Make My Day",
    image: `${SCI}/2017/04/Princess-58-_Make-My-Day_-Ibiza.jpeg`,
    images: [
      `${SCI}/2017/04/Princess-58-_Make-My-Day_-Ibiza.jpeg`,
      `${SCI}/2017/04/SCI_Exterior_Pics_Princess_V58_MakeMyDay_2024_011.jpg`,
    ],
    length: "58 ft / 17.7 m",
    guests: "Up to 12 guests",
    cabins: "3",
    cruisingSpeed: "32 knots",
    crew: "Captain + Crew",
    features: "Flybridge, luxury salon, full galley, swim platform",
    marina: "Marina Ibiza",
    pricing: { low: "€3,699", mid: "€3,999", high: "€4,299" },
    priceNote: "Price does not include VAT or fuel.",
    includes: ["Skipper", "Mooring", "Beverages", "Paddle Surf", "Snorkels", "Towels"],
    description:
      "The Princess V58 is a majestic British-built sport yacht that combines elegance with impressive performance. Its spacious flybridge and luxury salon provide multiple entertaining areas, while three generous cabins below deck offer comfortable retreats.",
  },
  {
    slug: "princess-v65-juliet",
    name: "Princess V65",
    boatName: "Princess Juliet",
    image: `${SCI}/2023/06/Princess_65_Juliet_01.png`,
    images: [
      `${SCI}/2023/06/Princess_65_Juliet_01.png`,
      `${SCI}/2023/06/LOW_SCI_Exterior_PrincessV65_PrincessJuliet_2023_001.jpg`,
    ],
    length: "65 ft / 19.8 m",
    guests: "Up to 12 guests",
    cabins: "3",
    cruisingSpeed: "34 knots",
    crew: "Captain + Crew",
    features: "Sport bridge, luxury interior, bow sunbed, tender garage",
    marina: "Marina Ibiza",
    pricing: { low: "€3,999", mid: "€4,299", high: "€4,599" },
    priceNote: "Price does not include VAT or fuel.",
    includes: ["Skipper", "Mooring", "Beverages", "Paddle Surf", "Snorkels", "Towels"],
    description:
      "The Princess V65 is a commanding sport yacht that delivers breathtaking performance alongside refined British luxury. Its sport bridge offers panoramic views while cruising, and the meticulously crafted interior salon provides elegant comfort.",
  },
  {
    slug: "sunseeker-predator-68",
    name: "Sunseeker Predator 68",
    boatName: "Talan",
    image: `${SCI}/2025/04/SCI_High_Exterior_Pictures_Sunseeker_Predator_68_Talan_2024_011.jpeg`,
    images: [
      `${SCI}/2025/04/SCI_High_Exterior_Pictures_Sunseeker_Predator_68_Talan_2024_011.jpeg`,
    ],
    length: "68 ft / 20.7 m",
    guests: "Up to 12 guests",
    cabins: "3",
    cruisingSpeed: "32 knots",
    crew: "Captain + Crew",
    features: "Hardtop, luxury saloon, aft deck, bow sunpad",
    marina: "Marina Ibiza",
    pricing: { low: "€3,999", mid: "€4,299", high: "€4,599" },
    priceNote: "Price does not include VAT or fuel.",
    includes: ["Skipper", "Mooring", "Beverages", "Paddle Surf", "Snorkels", "Towels"],
    description:
      "The Sunseeker Predator 68 is a legendary British sport yacht that has defined the genre for decades. Its aggressive lines and powerful performance are complemented by a luxurious interior with full saloon, spacious cabins, and expansive aft deck for al fresco entertaining.",
  },
  {
    slug: "princess-v65-ii",
    name: "Princess V65",
    boatName: "Freedom",
    image: `${SCI}/2022/11/Princess_v65_005.png`,
    images: [
      `${SCI}/2022/11/Princess_v65_005.png`,
    ],
    length: "65 ft / 19.8 m",
    guests: "Up to 12 guests",
    cabins: "3",
    cruisingSpeed: "34 knots",
    crew: "Captain + Crew",
    features: "Sport bridge, luxury interior, bow sunbed, tender garage",
    marina: "Marina Ibiza",
    pricing: { low: "€4,299", mid: "€4,599", high: "€4,999" },
    priceNote: "Price does not include VAT or fuel.",
    includes: ["Skipper", "Mooring", "Beverages", "Paddle Surf", "Snorkels", "Towels"],
    description:
      "The Princess V65 delivers breathtaking performance alongside refined British luxury. Its sport bridge offers panoramic views while cruising, and the meticulously crafted interior provides elegant comfort for extended charters.",
  },
  {
    slug: "baia-70",
    name: "Baia 70",
    boatName: "Chilli",
    image: `${SCI}/2021/05/Baia_70_003.png`,
    images: [
      `${SCI}/2021/05/Baia_70_003.png`,
    ],
    length: "70 ft / 21.3 m",
    guests: "Up to 12 guests",
    cabins: "3",
    cruisingSpeed: "35 knots",
    crew: "Captain + Crew",
    features: "Open yacht design, massive deck, luxury interior",
    marina: "Marina Ibiza",
    pricing: { low: "€5,599", mid: "€5,999", high: "€6,499" },
    priceNote: "Price does not include VAT or fuel.",
    includes: ["Skipper", "Mooring", "Beverages", "Paddle Surf", "Snorkels", "Towels"],
    description:
      "The Baia 70 is a stunning Italian open yacht that combines extraordinary performance with expansive deck living. Its massive open layout creates an unmatched outdoor entertaining space, while the refined interior offers three luxurious cabins for overnight comfort.",
  },
  {
    slug: "leopard-90",
    name: "Leopard 90",
    boatName: "aYa One",
    image: `${SCI}/2024/07/SCI_High_Exterior_Leopard90_AyaOne_2025_0111.png`,
    images: [
      `${SCI}/2024/07/SCI_High_Exterior_Leopard90_AyaOne_2025_0111.png`,
    ],
    length: "90 ft / 27.4 m",
    guests: "Up to 12 guests",
    cabins: "4",
    cruisingSpeed: "30 knots",
    crew: "Captain + 2 Crew",
    features: "Flybridge, jacuzzi, multiple salons, full crew quarters",
    marina: "Marina Ibiza",
    pricing: { low: "€6,999", mid: "€7,499", high: "€7,999" },
    priceNote: "Price does not include VAT or fuel.",
    includes: ["Skipper", "Crew", "Mooring", "Beverages", "Paddle Surf", "Snorkels", "Towels"],
    description:
      "The Leopard 90 is a true superyacht that commands attention wherever it anchors. Its flybridge with jacuzzi, multiple luxurious salons, and spacious cabins provide the ultimate charter experience. Full crew service ensures every detail is attended to.",
  },
  {
    slug: "azimut-86",
    name: "Azimut 86",
    boatName: "The Jungle",
    image: `${SCI}/2025/06/Azimut_86_The_Jungle_01-2.png`,
    images: [
      `${SCI}/2025/06/Azimut_86_The_Jungle_01-2.png`,
    ],
    length: "86 ft / 26.2 m",
    guests: "Up to 12 guests",
    cabins: "4",
    cruisingSpeed: "28 knots",
    crew: "Captain + 2 Crew",
    features: "Flybridge, full beam master, luxury salons, jacuzzi",
    marina: "Marina Ibiza",
    pricing: { low: "€7,999", mid: "€8,499", high: "€8,999" },
    priceNote: "Price does not include VAT or fuel.",
    includes: ["Skipper", "Crew", "Mooring", "Beverages", "Paddle Surf", "Snorkels", "Towels"],
    description:
      "The Azimut 86 represents the pinnacle of Italian superyacht design. Its full-beam master cabin, expansive flybridge, and multiple luxurious salons create a floating palace on the water. Every surface reflects meticulous craftsmanship and attention to detail.",
  },
  {
    slug: "canados-90",
    name: "Canados 90",
    boatName: "Funky Town",
    image: `${SCI}/2019/04/HIGH_SCI_Exterior_Canados90_Funky_Town_2023_322-7.png`,
    images: [
      `${SCI}/2019/04/HIGH_SCI_Exterior_Canados90_Funky_Town_2023_322-7.png`,
    ],
    length: "90 ft / 27.4 m",
    guests: "Up to 12 guests",
    cabins: "4",
    cruisingSpeed: "28 knots",
    crew: "Captain + 2 Crew",
    features: "Flybridge, luxury salons, full galley, tender",
    marina: "Marina Ibiza",
    pricing: { low: "€7,999", mid: "€8,499", high: "€8,999" },
    priceNote: "Price does not include VAT or fuel.",
    includes: ["Skipper", "Crew", "Mooring", "Beverages", "Paddle Surf", "Snorkels", "Towels"],
    description:
      "The Canados 90 is a distinguished Italian superyacht that combines classic elegance with modern luxury. Its expansive flybridge, refined salons, and generous entertaining spaces make it ideal for large groups seeking an unforgettable charter.",
  },
  {
    slug: "mangusta-92",
    name: "Mangusta 92",
    boatName: "Drift",
    image: `${SCI}/2022/03/Mangusta-Drift-176.png`,
    images: [
      `${SCI}/2022/03/Mangusta-Drift-176.png`,
      `${SCI}/2022/03/Mangusta-Drift-58.jpg`,
    ],
    length: "92 ft / 28 m",
    guests: "Up to 12 guests",
    cabins: "4",
    cruisingSpeed: "34 knots",
    crew: "Captain + 2 Crew",
    features: "Open yacht, massive sunbeds, luxury salons, tender",
    marina: "Marina Ibiza",
    pricing: { low: "€9,799", mid: "€10,499", high: "€11,199" },
    priceNote: "Price does not include VAT or fuel.",
    includes: ["Skipper", "Crew", "Mooring", "Beverages", "Paddle Surf", "Snorkels", "Towels"],
    description:
      "The Mangusta 92 is an iconic Italian open superyacht celebrated for its breathtaking speed and sleek design. Its massive open deck creates a social paradise, while the luxurious interior offers refined comfort across multiple cabins and salons.",
  },
  {
    slug: "sunseeker-predator-92",
    name: "Sunseeker Predator 92",
    boatName: "Nova 92",
    image: `${SCI}/2022/05/nova92-1.png`,
    images: [
      `${SCI}/2022/05/nova92-1.png`,
      `${SCI}/2022/05/Nova-92-Drone-1100.jpg`,
      `${SCI}/2022/05/Nova-92-Drone-17-e1749811623539.jpg`,
    ],
    length: "92 ft / 28 m",
    guests: "Up to 12 guests",
    cabins: "4",
    cruisingSpeed: "30 knots",
    crew: "Captain + 2 Crew",
    features: "Hardtop, flybridge, luxury cabins, full crew quarters",
    marina: "Marina Ibiza",
    pricing: { low: "€9,799", mid: "€10,499", high: "€11,199" },
    priceNote: "Price does not include VAT or fuel.",
    includes: ["Skipper", "Crew", "Mooring", "Beverages", "Paddle Surf", "Snorkels", "Towels"],
    description:
      "The Sunseeker Predator 92 is the ultimate expression of British sport yacht design at superyacht scale. Its aggressive stance and powerful performance are matched by a lavish interior featuring multiple luxury cabins, a grand saloon, and spacious flybridge.",
  },
  {
    slug: "maiora-99",
    name: "Maiora 99",
    boatName: "Lady KC",
    image: `${SCI}/2021/05/Lady-KC-62.jpg`,
    images: [
      `${SCI}/2021/05/Lady-KC-62.jpg`,
      `${SCI}/2021/05/Lady-KC-52.jpg`,
    ],
    length: "99 ft / 30.2 m",
    guests: "Up to 12 guests",
    cabins: "5",
    cruisingSpeed: "26 knots",
    crew: "Captain + 2 Crew",
    features: "Flybridge, jacuzzi, formal dining, multiple salons",
    marina: "Marina Ibiza",
    pricing: { low: "€9,999", mid: "€10,999", high: "€11,999" },
    priceNote: "Price does not include VAT or fuel.",
    includes: ["Skipper", "Crew", "Mooring", "Beverages", "Paddle Surf", "Snorkels", "Towels"],
    description:
      "The Maiora 99 is an impressive Italian superyacht offering nearly 100 feet of pure luxury. Its five spacious cabins, formal dining area, multiple salons, and flybridge with jacuzzi create a complete resort experience on the water.",
  },
  {
    slug: "leopard-102-dark-knight",
    name: "Leopard 102",
    boatName: "Dark Knight",
    image: `${SCI}/2022/11/Leopard_102_Dark_knight_0010.png`,
    images: [
      `${SCI}/2022/11/Leopard_102_Dark_knight_0010.png`,
      `${SCI}/2022/11/Screenshot-2023-10-16-at-12.25.35.png`,
    ],
    length: "102 ft / 31 m",
    guests: "Up to 12 guests",
    cabins: "5",
    cruisingSpeed: "28 knots",
    crew: "Captain + 3 Crew",
    features: "Flybridge, jacuzzi, multiple decks, VIP suites",
    marina: "Marina Ibiza",
    pricing: { low: "€12,999", mid: "€13,999", high: "€14,999" },
    priceNote: "Price does not include VAT or fuel.",
    includes: ["Skipper", "Crew", "Mooring", "Beverages", "Paddle Surf", "Snorkels", "Towels"],
    description:
      "The Leopard 102 is a commanding superyacht that delivers an unparalleled luxury charter experience. Multiple decks offer endless entertainment options, from the flybridge with jacuzzi to the spacious aft deck and refined interior salons.",
  },
  {
    slug: "leopard-102-la-romana",
    name: "Leopard 102",
    boatName: "La Romana",
    image: `${SCI}/2024/08/Leopard_102_La_romana_002.png`,
    images: [
      `${SCI}/2024/08/Leopard_102_La_romana_002.png`,
      `${SCI}/2024/08/Screenshot-2024-08-21-at-13.27.05.png`,
    ],
    length: "102 ft / 31 m",
    guests: "Up to 12 guests",
    cabins: "5",
    cruisingSpeed: "28 knots",
    crew: "Captain + 3 Crew",
    features: "Flybridge, jacuzzi, multiple decks, VIP suites",
    marina: "Marina Ibiza",
    pricing: { low: "€12,999", mid: "€13,999", high: "€14,999" },
    priceNote: "Price does not include VAT or fuel.",
    includes: ["Skipper", "Crew", "Mooring", "Beverages", "Paddle Surf", "Snorkels", "Towels"],
    description:
      "The Leopard 102 delivers a commanding superyacht experience with multiple decks, a flybridge jacuzzi, and lavish interior salons. Every detail reflects Italian craftsmanship at its finest, creating an unforgettable day on the Mediterranean.",
  },
  {
    slug: "benetti-115",
    name: "Benetti 115",
    boatName: "Friendship",
    image: `${SCI}/2025/06/Benetti-195.png`,
    images: [
      `${SCI}/2025/06/Benetti-195.png`,
      `${SCI}/2025/06/WhatsApp-Image-2025-06-18-at-18.54.35-9.jpeg`,
      `${SCI}/2025/06/WhatsApp-Image-2025-06-18-at-18.54.34-4.jpeg`,
      `${SCI}/2025/06/WhatsApp-Image-2025-06-18-at-18.54.36.jpeg`,
      `${SCI}/2025/06/WhatsApp-Image-2025-06-18-at-18.54.35-8.jpeg`,
    ],
    length: "115 ft / 35 m",
    guests: "Up to 12 guests",
    cabins: "5",
    cruisingSpeed: "22 knots",
    crew: "Captain + 5 Crew",
    features: "Multiple decks, grand salon, jacuzzi, tender, jet skis",
    marina: "Marina Ibiza",
    pricing: { low: "€13,999", mid: "€14,999", high: "€15,999" },
    priceNote: "Price does not include VAT or fuel.",
    includes: ["Skipper", "Full Crew", "Mooring", "Beverages", "Paddle Surf", "Snorkels", "Towels", "Jet Skis"],
    description:
      "The Benetti 115 is the crown jewel of our charter fleet — a magnificent Italian superyacht offering 115 feet of uncompromising luxury. Multiple decks, a grand salon, jacuzzi, and a full complement of water toys create an extraordinary floating resort.",
  },
];
